import * as React from 'react';

import {RemoveButton} from 'shells/button/remove-button/remove-button';
import {Card} from 'shells/card/card';

import styles from './connected-field-card.module.css';

type Props = {
    content: React.ReactNode;
    onRemove: () => void | null | undefined;
};

export function ConnectedFieldCard(props: Props) {
    return (
        // @ts-expect-error
        <Card hasBorder={true} isFullWidth={true}>
            <div className={styles.content}>
                {props.content}
                {props.onRemove ? <RemoveButton onClick={props.onRemove} size={12} /> : undefined}
            </div>
        </Card>
    );
}
